module.exports = __webpack_public_path__ + "static/media/Floorplan_Icon.dc4a08f8.svg";